import React, { useEffect, useRef, useReducer } from 'react'
import { Switch, Route, useLocation, Link } from 'react-router-dom'

import { useGlobalState } from '@/state'
import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import DefaultButton from '@/shared/Buttons/Default'
import EventIndex from '@/pages/EventIndex'
import PastEventsIndex from '@/pages/PastEventsIndex'
import MyWorkouts from '@/pages/MyWorkouts'

function breadCrumbs() {
  const location = useLocation()
  const activePath = location.pathname
  const crumbs = []
  if (activePath === '/workouts') {
    crumbs.push({ to: '/workouts', name: 'Workouts' })
  }
  if (activePath.includes('/workouts/')) {
    const [ currentWorkout ] = useGlobalState('currentWorkout')
    let crumb = currentWorkout?.name || 'Workout'
    crumbs.push({ to: activePath, name: crumb })
  }
  return crumbs
}

function pageTitle() {
  const location = useLocation()
  const activePath = location.pathname
  const titleInfo = {
     title: '',
    buttons: [ ]
  }
  if (activePath === '/workouts') { titleInfo.title = 'Workout' }
  if (activePath.includes('/workouts/')) {
    const [ currentWorkout ] = useGlobalState('currentWorkout')
    let title = currentWorkout?.name || 'Workout'
    titleInfo.title = title
  }
  return titleInfo
}

export default function WorkoutsContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()

  return <>
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={crumb.name} to={crumb.to} className="text-sm font-medium text-slate-500 hover:text-clcpurple dark:text-slate-300">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} exact path='/myworkouts'>
        <MyWorkouts />
      </Route>
    </Switch>
  </>
}
